<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav active"
      >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">地址：使用接入方提供的URL</p>
          <p class="api_addr_info">请求方法：<span>POST</span></p>
          <p class="api_addr_info">数据类型：<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">响应类型：<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";
export default {
  name: "settlementReturn",

  components: {onlineDoc},
  data() {
    return {
      onlineData: {
        //接口描述
        apiDesc: "将一段单于二段单绑定关系推送至客户",

        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: "接入方在平台的api账户标识",},
              {name: "digest", type: "String", require: "Y", normal: "", describe: "签名字符串",},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: "时间戳，毫秒",},
            ]
          },
          {
            title:'请求参数',
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
            ]
          },
          {
            title: "业务参数",
            value: [
              {name: "preOrderNo", type: "String", require: "Y", normal: "", describe: "一段快递运单号"},
              {name: "expressCompany", type: "String", require: "Y", normal: "", describe: "快递公司"},
              {name: "waybillNo", type: "String", require: "Y", normal: "", describe: "二段运单号"}
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [

          //   响应参数
          {
            title: '响应参数',
            value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: "返回码，见附录"},
              {name: "msg", type: "String", require: "Y", normal: "", describe: "描述"},
              {name: "data", type: "String", require: "Y", normal: "", describe: "业务数据"},
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
apiAccount=1362
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921

Body：
bizContent={
  "preOrderNo": "123",
  "expressCompany": '中通',
  "waybillNo": 'JT123',
}
`,
        //返回示例
        responseCode: {
          'code': '1',
          'msg': 'success',
          'data':"SUCCESS"
        } ,
        errcodeJson: []
      }
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
